<div>
    <div class="mb-3">
        <label for="username" class="form-label">Username *</label>
        <input [(ngModel)]="username" type="text" class="form-control" name="username"
            [ngClass]=" {'validated': username.length >= 8, 'not-validated' : username.length < 8 }">
    </div>
    <div class="mb-3">
        <label for="name" class="form-label">Name</label>
        <input [(ngModel)]="name" type="text" class="form-control" name="name" required>
    </div>
    <div class="mb-3">
        <label for="password" class="form-label">Password *</label>
        <input [(ngModel)]="password" type="password" class="form-control" name="password"
        [ngClass]=" {'validated': password.length >= 8, 'not-validated' : password.length < 8 }">
    </div>
    <div class="mb-3">
        <label for="department" class="form-label">Department *</label>
        <select class="form-control" aria-label="Select a department" name="department" [(ngModel)]="department"
        [ngClass]=" {'validated': department !=0, 'not-validated' : department==0 }">
            <option value="0" selected>Please select a department</option>
            <option *ngFor="let item of departments[0]" value="{{item.id}}">{{item.name}}</option>
        </select>
    </div>
    <div class="remoark">* is required, username and password have a minimum length of 8 characters</div>
    <button (click)="save()" class="btn btn-primary">Save</button>
    <button (click)="cancel()" class="btn btn-primary">Cancel</button>
</div>

